export default __webpack_public_path__ + "static/media/details.327eacb6.svg";